import { render, staticRenderFns } from "./ReportPageTemplate.vue?vue&type=template&id=27348ff4&scoped=true&"
import script from "./ReportPageTemplate.vue?vue&type=script&lang=js&"
export * from "./ReportPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ReportPageTemplate.vue?vue&type=style&index=0&id=27348ff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27348ff4",
  null
  
)

export default component.exports